// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Eqqw","clinicsSelect":"styles_clinicsSelect__1nuzj"};